import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthService} from '@app/core/services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

	constructor(public authService: AuthService, public router: Router) {
	}

	public canActivate(): boolean {
		if (this.authService.loggedIn()) {
			return true;
		}
		this.router.navigate(['./login']);

		return false;
	}

}
